import { render, staticRenderFns } from "./DistributionSystem.vue?vue&type=template&id=15f1df46&scoped=true"
import script from "./DistributionSystem.vue?vue&type=script&lang=js"
export * from "./DistributionSystem.vue?vue&type=script&lang=js"
import style0 from "./DistributionSystem.vue?vue&type=style&index=0&id=15f1df46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f1df46",
  null
  
)

export default component.exports